import React from 'react';
import ProfilePage from './ProfilePage';

const CourierProfile: React.FC = () => {
  // Always use the vendor ProfilePage component for courier profile
  return <ProfilePage />;
};

export default CourierProfile;
